module.exports = __webpack_public_path__ + "img/28-5-2022_estrellas.66cce3b9.jpg";